<div>
  <!-- Team Colors -->
  <div *ngIf="field.key === 'team_colors'">
    <h2>Team Colors:</h2>
    <div *ngIf="record[field.key]" class="p-grid">
      <div *ngFor="let colorSet of record[field.key]; let i = index" class="p-col-12">
        <div>
          <strong>Team {{ i+1 }} Colors:</strong>
        </div>
        <div class="color-list p-col-12">
          <span *ngFor="let color of colorSet">
            <div class="color-display" [ngStyle]="{'background-color': color}"></div>
            {{ color }}
          </span>
        </div>
      </div>
    </div>
  </div>
  
    <!--  Colors -->
  <div *ngIf="field.key === 'colors' || field.key === 'colorStrings'">
      <h2>{{ field.label }}</h2>
    <div *ngIf="record[field.key]" class="p-grid">
      <div *ngFor="let color of record[field.key]; let i = index" class="p-col-12">
        <div>
          <strong class="color-title">Color {{ i+1 }}:</strong> 
        </div>
        <div [ngClass]="{'color-list': true, 'horizontal': layoutMode === 'horizontal', 'vertical': layoutMode === 'vertical'}">
          <div class="color-display" [ngStyle]="{'background-color': color}"></div>
          {{ color }}
        </div>
      </div>
    </div>
  </div>

  <!-- Quality Level Multipliers and other generic nested inputs -->
  <div *ngIf="shouldShowNestedData()">
    <h2>{{ field.label || field.name }}:</h2>
    <div *ngIf="record[field.key] && record[field.key].length > 0" class="p-grid">
      <div class="p-col-12">
        <div class="nested-data-table">
          <div *ngFor="let item of record[field.key]; let i = index" class="nested-item">
            <div class="item-header">
              <strong>{{ field.label || field.name }} {{ i+1 }}:</strong>
            </div>
            <div class="item-content">
              <div *ngFor="let key of getObjectKeys(item)" class="item-field">
                <span class="field-label">{{ key }}:</span>
                <span class="field-value">{{ getDisplayValue(item[key]) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

